var map = {
	"./achievements.svg": 96,
	"./address_image.svg": 172,
	"./andres.png": 173,
	"./awslogo.png": 174,
	"./blogs_image.svg": 175,
	"./cenitlogo.png": 176,
	"./cinema.svg": 97,
	"./climbing.svg": 177,
	"./climbing1.svg": 98,
	"./coding.svg": 99,
	"./contactMail.png": 178,
	"./data_science.svg": 179,
	"./developerActivity.svg": 180,
	"./dragonbab.jpeg": 181,
	"./eating.svg": 100,
	"./education.svg": 182,
	"./experience.svg": 183,
	"./feelingProud.svg": 184,
	"./fullstack.svg": 185,
	"./gaming.svg": 101,
	"./github_logo.png": 186,
	"./google_logo.png": 187,
	"./googlecloudlogo.png": 188,
	"./hiventureslogo.png": 189,
	"./itamconstruye.jpg": 190,
	"./itamlogo.png": 191,
	"./madfellow.png": 192,
	"./manOnTable.svg": 193,
	"./microsoft_logo.png": 194,
	"./moon.svg": 195,
	"./platzilogo.png": 196,
	"./portfolio.gif": 197,
	"./programmer.svg": 198,
	"./projects_image.svg": 199,
	"./rdt.png": 200,
	"./reading.svg": 102,
	"./santanderlogo.png": 201,
	"./skill.svg": 95,
	"./soccer.svg": 103,
	"./sports.svg": 104,
	"./sun.svg": 202,
	"./ui_ux_design.svg": 203,
	"./unamlogo.png": 204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;